<div class = "ui-modal">
    <div class = "ui-modal-header-container ui-health-analysis-detail">
        <div class = "ui-header-container">
            <div class = "ui-health-analysis-icon ui-panel-primary-active ui-panel-bordered">
                <i [class] = "'ui-icon ' + analysis.detail.healthAnalysisType.configuration.icon">
                </i>
            </div>
            <div class = "ui-header-title-container">
                <div class = "ui-header-title">
                    <span class = "ui-title">{{ analysis.analysisIdentifier }}</span>
                    <div class = "ui-panel-primary-active">
                        {{ analysisStep.alias }}
                    </div>
                </div>
                <div class = "ui-header-sub-title">
                    {{ analysis.detail.healthAnalysisType.name }}
                </div>
            </div>
        </div>
        <div class = "ui-health-analysis-steps">
            @for (step of steps; track step.name; let i = $index) {
                @if (step.name !== 'RECOLLECTED') {
                    <div class = "ui-health-analysis-step" [ngClass] = "{
                        'ui-health-analysis-step-done': i < analysisStepIndex,
                        'ui-health-analysis-step-actual': i === analysisStepIndex
                    }">
                        <div class = "ui-health-analysis-step-detail">
                            <i class = "ui-icon {{  step.icon }}"></i>
                            <span class = "ui-label">
                                {{ step.alias }}
                            </span>
                        </div>
                        @if (i + 2 < steps.length) {
                            <div class = "ui-divisor"></div>
                        }
                    </div>
                }
            }
        </div>
        <div class = "ui-tab-sections-container">
            <button (click) = "selectedTab = 'detail'" [class] = "'ui-button ' + ((selectedTab === 'detail') ? 'ui-button-tab-active' : '' ) ">
                <span class = "ui-button-label">Visão Geral</span>
            </button>
            <button (click) = "selectedTab = 'timeline'" [class] = "'ui-button ' + ((selectedTab === 'timeline') ? 'ui-button-tab-active' : '' ) ">
                <span class = "ui-button-label">Timeline</span>
            </button>
            <button (click) = "selectedTab = 'files'" [class] = "'ui-button ' + ((selectedTab === 'files') ? 'ui-button-tab-active' : '' ) ">
                <span class = "ui-button-label">Arquivos</span>
            </button>
        </div>
    </div>
    <div class = "ui-modal-body-container">
        <app-health-analysis-detail-general-data *ngIf = "selectedTab === 'detail'" [analysis] = "analysis"></app-health-analysis-detail-general-data>
        <app-health-analysis-detail-timeline *ngIf = "selectedTab === 'timeline'" [timeline] = "timeline"></app-health-analysis-detail-timeline>
        <app-health-analysis-detail-files *ngIf = "selectedTab === 'files'" [files] = "files" [analysis] = "analysis"></app-health-analysis-detail-files>
    </div>

    <div class = "ui-modal-footer-container">
        <button class = "ui-button" (click) = "eventClose()">
            <span class = "ui-button-label"> Fechar</span>
        </button>
    </div>
</div>

    <!--<div class = "ui-modal-body-container">-->
    <!--    <div class = "ui-health-analysis-detail-container">-->
    <!--        <div class = "ui-health-analysis-detail-icon ui-panel-blue">-->
    <!--            <img [src] = "analysis.detail.healthAnalysisType.configuration.icon">-->
    <!--        </div>-->
    <!--        <div class = "ui-health-analysis-detail">-->
    <!--            <div class = "ui-health-analysis-detail-name">-->
    <!--                <span class = "ui-gradient-text"> {{ analysis.analysisIdentifier }}</span>-->
    <!--            </div>-->
    <!--            <div class = "ui-health-analysis-detail-type">-->
    <!--                {{ analysis.detail.healthAnalysisType.name }}-->
    <!--            </div>-->
    <!--        </div>-->

    <!--</div>-->

